import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';

export const Container = styled.div`
  padding: 0 ${theme.spacing.lg};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 492px;

  ${media.tablet`
    padding: 0 40px;
    height: 737px;
  `}

  ${media.desktop`
    padding: 0 74px;
  `}
`;

export const Paragraph = styled.p`
  margin: 0;
  font-weight: ${theme.typography.fontWeight.regular};
  color: ${theme.colors.text.primary};
`;

export const Title = styled(Paragraph)`
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.display5};
  line-height: ${theme.typography.lineHeight.display5};
  color: ${theme.colors.text.brand};

  ${media.tablet`
     font-size: ${theme.typography.fontSize.display4};
    line-height: ${theme.typography.lineHeight.display4};
  `}
`;

export const Subtitle = styled(Paragraph)`
  margin-top: ${theme.spacing.md};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h4};
  line-height: ${theme.typography.lineHeight.h4};

  ${media.tablet`
    margin-top: ${theme.spacing.lg};
    font-size: ${theme.typography.fontSize.h4};
    line-height: ${theme.typography.lineHeight.h4};
  `}

  ${media.desktop`
    margin-top: ${theme.spacing.lg};
  `}
`;

export const Description = styled(Paragraph)`
  margin-top: ${theme.spacing.md};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};

  ${media.tablet`
    margin-top: ${theme.spacing.sm};
    font-size: ${theme.typography.fontSize.body2};
    line-height: ${theme.typography.lineHeight.body2};
  `}

  ${media.desktop`
    font-size: ${theme.typography.fontSize.body2};
    line-height: ${theme.typography.lineHeight.body2};
  `}
`;
